// import React, { useContext, useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { FaSearch, FaTimes, FaEdit, FaTrash } from "react-icons/fa";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";
// import Select from "react-select";
// import { PlusIcon } from "lucide-react";

// export default function Todo() {
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [todos, setTodos] = useState([]);
//   const [activeTab, setActiveTab] = useState("assigned");
//   const [isSearching, setIsSearching] = useState(false);
//   const [showFields, setShowFields] = useState(false);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [currentTodoId, setCurrentTodoId] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [todoToDelete, setTodoToDelete] = useState(null);
//   const [currentTodoForUnassign, setCurrentTodoForUnassign] = useState(null);
//   const [showAttachmentModal, setShowAttachmentModal] = useState(false);
//   const [currentAttachment, setCurrentAttachment] = useState(null);
//   const [attachmentType, setAttachmentType] = useState("");
//   const [attachmentFilename, setAttachmentFilename] = useState("");
//   const [expandedMessages, setExpandedMessages] = useState({});
//   const [pageNumber, setPageNumber] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalPages, setTotalPages] = useState(0);
//   const [statusOptions, setStatusOptions] = useState([]);

//   const [newTodo, setNewTodo] = useState({
//     file: null,
//     companyId:
//       user?.accountType === "COMPANY" ? user.id : user?.companyId || "",
//     date: "",
//     todoMessage: "",
//     priority: "",
//     createdById: user?.id || "",
//     createdByName: user?.name || "",
//     status: "",
//     createdAt: new Date().toISOString(),
//     todoType: "",
//     assignedTo: "",
//     assignedToOptions: [],
//   });

//   const [searchParams, setSearchParams] = useState({
//     companyId: "",
//     todoMessage: "",
//     status: "",
//     targetUserId: "",
//   });

//   useEffect(() => {
//     async function fetchStatus() {
//       if (!user) return;
//       const companyId =
//         user.accountType === "COMPANY" ? user.id : user.companyId;
//       try {
//         const response = await axios.get(
//           `${API_URL}/api/leadStatus/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );
//         setStatusOptions(response.data || []);
//       } catch (error) {
//         console.error("Error fetching status:", error);
//       }
//     }
//     fetchStatus();
//   }, [user]);

//   const handleNewTodoChange = (eOrValue, meta) => {
//     if (meta && meta.name === "assignedToJson") {
//       const assignedUsers = eOrValue.map((option) => ({
//         id: option.value,
//         name: option.label,
//       }));

//       setNewTodo((prev) => ({
//         ...prev,
//         assignedTo: JSON.stringify(assignedUsers),
//         assignedToOptions: eOrValue, // Store the selected options
//       }));
//     } else {
//       const { name, value, type, files } = eOrValue.target;
//       if (type === "file") {
//         setNewTodo((prev) => ({ ...prev, file: files[0] }));
//       } else {
//         setNewTodo((prev) => ({ ...prev, [name]: value }));
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!newTodo.todoMessage || !newTodo.date) {
//       toast.error("Todo message and date are required");
//       return;
//     }

//     try {
//       const formData = new FormData();

//       Object.keys(newTodo).forEach((key) => {
//         if (key !== "assignedToOptions" && newTodo[key] !== null) {
//           formData.append(key, newTodo[key]);
//         }
//       });

//       const config = {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "multipart/form-data",
//         },
//       };

//       const response =
//         isEditing && currentTodoId
//           ? await axios.put(
//               `${API_URL}/api/todos/${currentTodoId}`,
//               formData,
//               config
//             )
//           : await axios.post(`${API_URL}/api/todos`, formData, config);

//       const { status, message } = response.data;

//       if (status === "Successful") {
//         toast.success(message); // ✅ Show toast: "Todo created/updated successfully"
//         setShowAddModal(false);
//         fetchTodos(); // ✅ Refresh list
//         resetForm(); // ✅ Clear form fields
//       } else {
//         toast.error(message || "Something went wrong!");
//       }
//     } catch (error) {
//       console.error("Error submitting todo:", error);
//       toast.error(error.response?.data?.message || "Failed to submit todo");
//     }
//   };

//   // Helper function to reset form
//   const resetForm = () => {
//     setNewTodo({
//       file: null,
//       companyId:
//         user?.accountType === "COMPANY" ? user.id : user?.companyId || "",
//       date: "",
//       todoMessage: "",
//       priority: "",
//       createdById: user?.id || "",
//       createdByName: user?.name || "",
//       status: "",
//       createdAt: new Date().toISOString(),
//       todoType: "",
//       assignedTo: "",
//       assignedToOptions: [],
//     });
//     setIsEditing(false);
//     setCurrentTodoId(null);
//   };

//   const handleEditClick = (todo) => {
//     setCurrentTodoId(todo.todoId);
//     setIsEditing(true);

//     // Convert assignedTo array to the format expected by react-select
//     const assignedToOptions =
//       todo.assignedTo && Array.isArray(todo.assignedTo)
//         ? todo.assignedTo.map((user) => ({
//             value: user.id,
//             label: user.name,
//           }))
//         : [];

//     setNewTodo({
//       ...todo,
//       assignedTo: JSON.stringify(todo.assignedTo || []),
//       assignedToOptions, // Store for Select component
//     });

//     setShowAddModal(true);
//   };

//   const toggleMessageExpansion = (todoId) => {
//     setExpandedMessages((prev) => ({
//       ...prev,
//       [todoId]: !prev[todoId],
//     }));
//   };

//   const MAX_MESSAGE_LENGTH = 50; // Adjust this as needed

//   const handleSearchChange = (e) => {
//     const { name, value } = e.target;
//     setSearchParams((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     setIsSearching(true);
//     setPageNumber(0); // Reset to first page when searching
//     try {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;
//       if (!companyId) return;

//       const params = {
//         ...Object.fromEntries(
//           Object.entries(searchParams).filter(([_, v]) => v !== "")
//         ),
//         pageNumber: 0, // Start from first page
//         pageSize: pageSize,
//       };

//       const response = await axios.get(
//         `${API_URL}/api/todos/searchTodos/${companyId}/${user?.id}`,
//         {
//           params,
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       setTodos(response.data.todos || []);
//       setTotalPages(response.data.totalPages || 0);
//     } catch (error) {
//       toast.error("Failed to search tasks");
//       setTodos([]);
//       setTotalPages(0);
//     }
//   };

//   const handleClearSearch = () => {
//     setIsSearching(false);
//     setSearchParams({
//       companyId: "",
//       todoMessage: "",
//       status: "",
//       targetUserId: "",
//     });
//     setPageNumber(0); // Reset to first page
//     fetchTodos();
//   };

//   const fetchTodos = useCallback(async () => {
//     if (!user?.id) return;
//     try {
//       const endpoint =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/todos/company/${user.id}`
//           : activeTab === "assigned"
//           ? `${API_URL}/api/todos/assigned/${user.id}`
//           : `${API_URL}/api/todos/createdBy/${user.id}`;

//       const response = await axios.get(
//         `${endpoint}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       setTodos(Array.isArray(response.data.todos) ? response.data.todos : []);
//       setTotalPages(response.data.totalPages || 0);
//     } catch (error) {
//       // toast.error("Failed to fetch todos");
//       setTodos([]);
//       setTotalPages(0);
//     }
//   }, [user, activeTab, pageNumber, pageSize]);

//   useEffect(() => {
//     fetchTodos();
//   }, [user, activeTab, fetchTodos, pageNumber, pageSize]);

//   const handleViewAttachment = async (todo) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/api/todos/view/${todo.todoId}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       // Get filename from the todo's attachment field
//       const filename = todo.attachment;
//       const fileExtension = filename.split(".").pop().toLowerCase();

//       // Categorize the file type based on extension
//       let typeCategory = "other";
//       if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
//         typeCategory = "image";
//       } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
//         typeCategory = "video";
//       } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
//         typeCategory = "audio";
//       } else if (fileExtension === "pdf") {
//         typeCategory = "pdf";
//       } else if (["doc", "docx"].includes(fileExtension)) {
//         typeCategory = "word";
//       } else if (["xls", "xlsx"].includes(fileExtension)) {
//         typeCategory = "excel";
//       } else if (["ppt", "pptx"].includes(fileExtension)) {
//         typeCategory = "powerpoint";
//       } else if (["txt", "csv"].includes(fileExtension)) {
//         typeCategory = "text";
//       }

//       // Create object URL for the blob with proper MIME type
//       let fileUrl;
//       if (typeCategory === "pdf") {
//         const blob = new Blob([response.data], { type: "application/pdf" });
//         fileUrl = URL.createObjectURL(blob);
//       } else {
//         const blob = new Blob([response.data]);
//         fileUrl = URL.createObjectURL(blob);
//       }

//       setCurrentAttachment(fileUrl);
//       setAttachmentFilename(filename);
//       setAttachmentType(typeCategory);
//       setCurrentTodoForUnassign(todo.todoId);
//       setShowAttachmentModal(true);
//     } catch (error) {
//       toast.error("Failed to view attachment");
//       console.error(error);
//     }
//   };

//   const handleDownloadAttachment = async (todoId) => {
//     try {
//       const todo = todos.find((t) => t.todoId === todoId);
//       if (!todo || !todo.attachment) {
//         toast.error("Attachment not found");
//         return;
//       }

//       const response = await axios.get(
//         `${API_URL}/api/todos/download/${todoId}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       // Use the filename from the todo's attachment field
//       const filename = todo.attachment;

//       const blob = new Blob([response.data]);
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       toast.error("Failed to download attachment");
//       console.error(error);
//     }
//   };

//   const getOfficeViewerUrl = (fileUrl) => {
//     return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
//       fileUrl
//     )}`;
//   };

//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   const handleDeleteClick = (todoId) => {
//     setTodoToDelete(todoId);
//     setShowDeleteModal(true);
//   };

//   const confirmDelete = async () => {
//     if (!todoToDelete) return;

//     try {
//       const response = await axios.delete(
//         `${API_URL}/api/todos/${todoToDelete}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       toast.success(response.data.message);
//       fetchTodos();
//     } catch (error) {
//       toast.error(error.response?.data?.message || error.message);
//     } finally {
//       setShowDeleteModal(false);
//       setTodoToDelete(null);
//     }
//   };



//     // helper section for rendering for the date and  n formate of the DD-MM-YYYY adding date 27-01-2026
// const formatDate = (date) => {
//   if (!date) return "-";
//   const d = new Date(date);
//   const day = String(d.getDate()).padStart(2, "0");
//   const month = String(d.getMonth() + 1).padStart(2, "0");
//   const year = d.getFullYear();
//   return `${day}-${month}-${year}`;
// };


//   return (
//     <div className="p-2 sm:p-4 bg-gray-100 dark:bg-gray-900 rounded-lg shadow-lg">
//       <div className="p-2">
//         <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:justify-between sm:items-center">
//           {/* Left: Title */}
//           <h2 className="text-2xl font-bold">Todo Table</h2>

//           {/* Middle: Tabs (visible only if not COMPANY) */}
//           {user?.accountType !== "COMPANY" && (
//             <div className="flex flex-wrap gap-2">
//               <button
//                 className={`px-2 py-1 rounded ${
//                   activeTab === "assigned"
//                     ? "bg-blue-500 text-white"
//                     : "bg-gray-300"
//                 }`}
//                 onClick={() => setActiveTab("assigned")}
//               >
//                 Assigned
//               </button>
//               <button
//                 className={`px-2 py-1 rounded ${
//                   activeTab === "createdBy"
//                     ? "bg-blue-500 text-white"
//                     : "bg-gray-300"
//                 }`}
//                 onClick={() => setActiveTab("createdBy")}
//               >
//                 Created By
//               </button>
//             </div>
//           )}

//           {/* Right: Search and Add buttons */}
//           <div className="flex flex-wrap justify-end gap-2">
//             <button
//               onClick={() => setShowAddModal(true)}
//               type="button"
//               className="px-2 py-1 bg-indigo-600 text-white hover:bg-indigo-700 rounded flex items-center"
//             >
//               <PlusIcon className="w-5 h-5" />
//             </button>
//             <button
//               type="button"
//               onClick={() => setShowFields(!showFields)}
//               className="px-2 py-1 bg-indigo-600 text-white hover:bg-indigo-700 rounded flex items-center"
//             >
//               {showFields ? (
//                 <>
//                   <FaTimes className="mr-2 w-5 h-4" />
//                   Close
//                 </>
//               ) : (
//                 <>
//                   <FaSearch className="mr-2 w-5 h-4" />
//                   Search
//                 </>
//               )}
//             </button>
//           </div>
//         </div>

//         {showFields && (
//           <form
//             onSubmit={handleSearchSubmit}
//             className="p-2 bg-white dark:bg-gray-800 rounded shadow mb-2"
//           >
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-4 items-end">
//               <div>
//                 <label className="block text-sm font-semibold mb-1">User</label>
//                 <select
//                   name="targetUserId"
//                   value={searchParams.targetUserId}
//                   onChange={handleSearchChange}
//                   className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                 >
//                   <option value="">All</option>
//                   {users.map((user) => (
//                     <option key={user.id} value={user.id}>
//                       {user.fname} {user.lname}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold mb-1">Todo</label>
//                 <input
//                   type="text"
//                   name="todoMessage"
//                   value={searchParams.todoMessage}
//                   onChange={handleSearchChange}
//                   placeholder="Enter subject"
//                   className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold mb-1">
//                   Priority
//                 </label>
//                 <select
//                   name="priority"
//                   value={searchParams.priority}
//                   onChange={handleSearchChange}
//                   className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                 >
//                   <option value="">All</option>
//                   <option value="High">High</option>
//                   <option value="Medium">Medium</option>
//                   <option value="Low">Low</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm font-semibold mb-1">
//                   Status
//                 </label>
//                 <select
//                   name="status"
//                   value={searchParams.status}
//                   onChange={handleSearchChange}
//                   className="w-full p-1 border rounded bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                 >
//                   <option value="">All</option>
//                   {statusOptions.map((status) => (
//                     <option key={status.leadStatusId} value={status.name}>
//                       {status.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="flex justify-end gap-2 mt-2">
//               <button
//                 type="submit"
//                 className="px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center"
//               >
//                 <FaSearch className="mr-2" /> Search
//               </button>
//               {isSearching && (
//                 <button
//                   type="button"
//                   onClick={handleClearSearch}
//                   className="px-2 py-1 bg-gray-300 rounded hover:bg-gray-400 flex items-center"
//                 >
//                   <FaTimes className="mr-2" /> Clear
//                 </button>
//               )}
//             </div>
//           </form>
//         )}

//         <div className="overflow-x-auto rounded shadow ">
//           <table className="min-w-full bg-white border border-gray-200 text-xs dark:bg-gray-900 dark:text-white">
//             <thead className="bg-gray-50 dark:bg-gray-800 ">
//               <tr>
//                 <th className="px-3 py-1 text-left">S No.</th>
//                 <th className="px-3 py-1 text-left">Todo</th>
//                 <th className="px-3 py-1 text-left">Priority</th>
//                 <th className="px-3 py-1 text-left">Date</th>
//                 <th className="px-3 py-1 text-left">Assigned To</th>
//                 <th className="px-3 py-1 text-left">Assigned By</th>
//                 <th className="px-3 py-1 text-left">Status</th>
//                 <th className="px-3 py-1 text-left">Attachment</th>
//                 {(user?.accountType === "COMPANY" ||
//                         activeTab !== "assigned") && (
//                 <th className="px-3 py-1 text-left">Actions</th>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {todos.length > 0 ? (
//                 todos.map((todo, index) => (
//                   <tr key={todo.todoId} className="border-t">
//                     <td className="px-3 py-1">{index + 1}</td>
//                     <td className="px-3 py-1">
//                       {todo.todoMessage.length > MAX_MESSAGE_LENGTH ? (
//                         <>
//                           {expandedMessages[todo.todoId]
//                             ? todo.todoMessage
//                             : `${todo.todoMessage.substring(
//                                 0,
//                                 MAX_MESSAGE_LENGTH
//                               )}...`}
//                           <button
//                             onClick={() => toggleMessageExpansion(todo.todoId)}
//                             className="text-blue-600  hover:text-blue-800 dark:hover:text-blue-400 ml-2 text-sm"
//                           >
//                             {expandedMessages[todo.todoId]
//                               ? "View Less"
//                               : "View More"}
//                           </button>
//                         </>
//                       ) : (
//                         todo.todoMessage
//                       )}
//                     </td>
//                     <td className="px-3 py-1">{todo.priority}</td>
//                     {/* <td className="px-3 py-1">{ todo.date}</td> */}
//                      <td className="px-2 py-1">{formatDate(todo.date)}</td>
//                     <td className="px-3 py-1">
//                       {todo.assignedTo && Array.isArray(todo.assignedTo)
//                         ? todo.assignedTo.map((user) => user.name).join(", ")
//                         : "—"}
//                     </td>
//                     <td className="px-3 py-1">{todo.createdByName}</td>
//                     <td className="px-3 py-1">{todo.status}</td>
//                     <td>
//                       {todo.attachment ? (
//                         <button
//                           onClick={() => {
//                             setCurrentTodoForUnassign(todo.todoId);
//                             handleViewAttachment(todo);
//                           }}
//                           className="text-blue-600 underline hover:text-blue-800 dark:hover:text-blue-400"
//                         >
//                           View Attachment
//                         </button>
//                       ) : (
//                         <span className="text-gray-500 italic">
//                           No attachment
//                         </span>
//                       )}
//                     </td>
//                     {(user?.accountType === "COMPANY" ||
//                         activeTab !== "assigned") && (
//                     <td className="px-3 py-1 space-x-2">
//                         <>
//                           <button
//                             onClick={() => handleEditClick(todo)}
//                             title="Edit"
//                             className="text-blue-600 hover:text-blue-800 dark:hover:text-blue-400"
//                           >
//                             <FaEdit />
//                           </button>
//                           <button
//                             onClick={() => handleDeleteClick(todo.todoId)}
//                             title="Delete"
//                             className="text-red-600 hover:text-red-800 dark:hover:text-red-400"
//                           >
//                             <FaTrash />
//                           </button>
//                         </>
//                     </td>
//                     )}
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td
//                     colSpan="8"
//                     className="text-center px-4 py-6 text-gray-500"
//                   >
//                     No todos found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {totalPages > 0 && (
//   <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-4">
//     <div className="flex items-center gap-2">
//       <span className="text-sm text-gray-600 dark:text-gray-300">Items per page:</span>
//       <select
//         value={pageSize}
//         onChange={(e) => {
//           setPageSize(Number(e.target.value));
//           setPageNumber(0); // Reset to first page when changing page size
//         }}
//         className="border rounded p-1 text-sm dark:bg-gray-700 dark:text-white min-w-[60px]"
//       >
//         <option value="5">5</option>
//         <option value="10">10</option>
//         <option value="20">20</option>
//         <option value="50">50</option>
//       </select>
//     </div>

//     <div className="flex items-center gap-3 flex-wrap justify-center">
//       <button
//         onClick={() => setPageNumber(0)}
//         disabled={pageNumber === 0}
//         className="px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 dark:bg-gray-700 dark:text-white whitespace-nowrap"
//         title="First Page"
//       >
//         First
//       </button>
      
//       <button
//         onClick={() => {
//           const newPage = Math.max(pageNumber - 1, 0);
//           setPageNumber(newPage);
//         }}
//         disabled={pageNumber === 0}
//         className="px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 dark:bg-gray-700 dark:text-white whitespace-nowrap"
//         title="Previous Page"
//       >
//         Prev
//       </button>

//       <span className="text-sm font-medium dark:text-white whitespace-nowrap">
//         Page {pageNumber + 1} of {totalPages}
//       </span>

//       <button
//         onClick={() => {
//           const newPage = Math.min(pageNumber + 1, totalPages - 1);
//           setPageNumber(newPage);
//         }}
//         disabled={pageNumber >= totalPages - 1}
//         className="px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 dark:bg-gray-700 dark:text-white whitespace-nowrap"
//         title="Next Page"
//       >
//         Next
//       </button>
      
//       <button
//         onClick={() => setPageNumber(totalPages - 1)}
//         disabled={pageNumber >= totalPages - 1}
//         className="px-3 py-1 bg-blue-100 hover:bg-blue-200 text-sm text-blue-800 rounded disabled:opacity-50 dark:bg-gray-700 dark:text-white whitespace-nowrap"
//         title="Last Page"
//       >
//         Last
//       </button>
//     </div>
//   </div>
// )}

//         {showAddModal && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
//             <div className="relative bg-white dark:bg-gray-900 w-full max-w-screen-sm rounded-xl shadow-xl p-4 sm:p-6 max-h-[95vh] overflow-y-auto">
//               {/* Header */}
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
//                   {isEditing ? "Edit Todo" : "Create New Todo"}
//                 </h2>
//                 <button
//                   onClick={() => {
//                     setShowAddModal(false);
//                     resetForm();
//                   }}
//                   className="text-gray-500 hover:text-red-500 transition"
//                   aria-label="Close"
//                 >
//                   <FaTimes className="w-5 h-5" />
//                 </button>
//               </div>

//               {/* Form */}
//               <form
//                 onSubmit={handleSubmit}
//                 className="grid grid-cols-1 sm:grid-cols-2 gap-3"
//               >
//                 {/* Todo Message */}
//                 <div className="col-span-full">
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Todo Message <span className="text-red-500">*</span>
//                   </label>
//                   <textarea
//                     name="todoMessage"
//                     value={newTodo.todoMessage}
//                     onChange={handleNewTodoChange}
//                     placeholder="Enter todo message"
//                     className="w-full border border-gray-300 dark:border-gray-700 px-3 py-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none min-h-[100px] dark:bg-gray-900 dark:text-white"
//                     required
//                     rows={4}
//                   />
//                 </div>

//                 {/* Date */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Date <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="date"
//                     name="date"
//                     value={newTodo.date}
//                     onChange={handleNewTodoChange}
//                     min={new Date().toISOString().split("T")[0]}
//                     className="w-full border border-gray-300 dark:border-gray-700 px-3 py-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none dark:bg-gray-900 dark:text-white"
//                     required
//                   />
//                 </div>

//                 {/* Priority */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Priority <span className="text-red-500">*</span>
//                   </label>
//                   <select
//                     name="priority"
//                     value={newTodo.priority}
//                     onChange={handleNewTodoChange}
//                     className="w-full border border-gray-300 dark:border-gray-700 px-3 py-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none dark:bg-gray-900 dark:text-white"
//                     required
//                   >
//                     <option value="">Select Priority</option>
//                     <option value="Low">Low</option>
//                     <option value="Medium">Medium</option>
//                     <option value="High">High</option>
//                   </select>
//                 </div>

//                 {/* Status */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Status
//                   </label>
//                   <select
//                     name="status"
//                     value={newTodo.status}
//                     onChange={handleNewTodoChange}
//                     className="w-full border border-gray-300 dark:border-gray-700 px-3 py-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none dark:bg-gray-900 dark:text-white"
//                   >
//                     <option value="">Select Status</option>
//                     {statusOptions.map((status) => (
//                       <option
//                         key={status.leadStatusId}
//                         value={status.name}
//                         style={{
//                           backgroundColor: status.color,
//                           color: "#fff",
//                         }}
//                       >
//                         {status.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Todo Type */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Todo Type
//                   </label>
//                   <input
//                     type="text"
//                     name="todoType"
//                     value={newTodo.todoType}
//                     onChange={handleNewTodoChange}
//                     placeholder="Optional"
//                     className="w-full border border-gray-300 dark:border-gray-700 px-3 py-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none dark:bg-gray-900 dark:text-white"
//                   />
//                 </div>

//                 {/* File Upload */}
//                 <div className="col-span-full">
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Attach File
//                   </label>
//                   <input
//                     type="file"
//                     name="file"
//                     onChange={handleNewTodoChange}
//                     className="w-full border border-gray-300 dark:border-gray-700 px-3 py-2 rounded-md focus:outline-none dark:bg-gray-900 dark:text-white"
//                   />
//                 </div>

//                 {/* Assign To */}
//                 <div className="col-span-full">
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Assign To <span className="text-red-500">*</span>
//                   </label>
//                   <Select
//                     isMulti
//                     name="assignedToJson"
//                     options={users.map((user) => ({
//                       value: user.id,
//                       label: `${user.fname} ${user.lname}`,
//                     }))}
//                     value={newTodo.assignedToOptions}
//                     onChange={(selectedOptions, meta) =>
//                       handleNewTodoChange(selectedOptions, meta)
//                     }
//                     className="w-full"
//                     classNamePrefix="select"
//                     closeMenuOnSelect={false}
//                     placeholder="Select team members..."
//                     required
//                     noOptionsMessage={() => "No users available"}
//                     styles={{
//                       control: (base, state) => ({
//                         ...base,
//                         minHeight: "44px",
//                         borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
//                         boxShadow: state.isFocused
//                           ? "0 0 0 1px #3b82f6"
//                           : "none",
//                         borderRadius: "0.375rem",
//                         padding: "2px 4px",
//                         backgroundColor:
//                           document.documentElement.classList.contains("dark")
//                             ? "#374151" // gray-700
//                             : "white",
//                         color: document.documentElement.classList.contains(
//                           "dark"
//                         )
//                           ? "white"
//                           : "black",
//                         "&:hover": {
//                           borderColor: "#9ca3af", // gray-400
//                         },
//                       }),
//                       option: (base, { isFocused, isSelected }) => ({
//                         ...base,
//                         backgroundColor: isSelected
//                           ? "#3b82f6"
//                           : isFocused
//                           ? document.documentElement.classList.contains("dark")
//                             ? "#4b5563" // gray-600
//                             : "#f3f4f6" // gray-100
//                           : "transparent",
//                         color: isSelected
//                           ? "white"
//                           : document.documentElement.classList.contains("dark")
//                           ? "white"
//                           : "black",
//                         cursor: "pointer",
//                       }),
//                       menu: (base) => ({
//                         ...base,
//                         borderRadius: "0.375rem",
//                         marginTop: 4,
//                         backgroundColor:
//                           document.documentElement.classList.contains("dark")
//                             ? "#1f2937" // gray-800
//                             : "white",
//                         color: document.documentElement.classList.contains(
//                           "dark"
//                         )
//                           ? "white"
//                           : "black",
//                       }),
//                       multiValue: (base) => ({
//                         ...base,
//                         backgroundColor:
//                           document.documentElement.classList.contains("dark")
//                             ? "#6b7280" // gray-500
//                             : "#e5e7eb", // gray-200
//                         borderRadius: "0.375rem",
//                         padding: "2px 6px",
//                       }),
//                       multiValueLabel: (base) => ({
//                         ...base,
//                         color: document.documentElement.classList.contains(
//                           "dark"
//                         )
//                           ? "white"
//                           : "black",
//                       }),
//                       multiValueRemove: (base) => ({
//                         ...base,
//                         color: "#ef4444", // red-500
//                         ":hover": {
//                           backgroundColor: "#f87171", // red-400
//                           color: "white",
//                         },
//                       }),
//                     }}
//                     theme={(theme) => ({
//                       ...theme,
//                       colors: {
//                         ...theme.colors,
//                         primary: "#3b82f6",
//                         primary25: document.documentElement.classList.contains(
//                           "dark"
//                         )
//                           ? "#4b5563"
//                           : "#f3f4f6",
//                         primary50: document.documentElement.classList.contains(
//                           "dark"
//                         )
//                           ? "#6b7280"
//                           : "#e0e7ff",
//                       },
//                     })}
//                   />
//                 </div>

//                 {/* Buttons */}
//                 <div className="col-span-full flex justify-end gap-3 mt-3">
//                   <button
//                     type="button"
//                     onClick={() => setShowAddModal(false)}
//                     className="px-4 py-2 bg-gray-100 text-gray-800 rounded-md hover:bg-gray-200 transition"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="px-5 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition font-medium"
//                   >
//                     {isEditing ? "Update" : "Create"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}

//         {/* Delete Confirmation Modal */}
//         {showDeleteModal && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
//             <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 w-full max-w-md">
//               <div className="flex flex-col items-center">
//                 <div className="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mb-4">
//                   <FaTrash className="text-red-600 dark:text-red-400 text-xl" />
//                 </div>
//                 <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
//                   Delete Todo
//                 </h3>
//                 <p className="text-gray-500 dark:text-gray-400 text-center mb-6">
//                   Are you sure you want to delete this todo? This action cannot
//                   be undone.
//                 </p>
//                 <div className="flex justify-center gap-3 w-full">
//                   <button
//                     onClick={() => {
//                       setShowDeleteModal(false);
//                       setTodoToDelete(null);
//                     }}
//                     className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={confirmDelete}
//                     className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//         {showAttachmentModal && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4">
//             <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl p-4 sm:p-6 w-full max-w-full sm:max-w-4xl h-[90vh] flex flex-col">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-lg font-medium text-gray-900 dark:text-white truncate max-w-[80%]">
//                   {attachmentFilename}
//                 </h3>
//                 <button
//                   onClick={() => {
//                     setShowAttachmentModal(false);
//                     if (currentAttachment) {
//                       URL.revokeObjectURL(currentAttachment);
//                     }
//                   }}
//                   className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 p-1"
//                 >
//                   <FaTimes className="w-5 h-5" />
//                 </button>
//               </div>

//               <div className="flex-1 flex flex-col items-center overflow-hidden">
//                 {attachmentType === "image" ? (
//                   <img
//                     src={currentAttachment}
//                     alt="Attachment preview"
//                     className="max-h-full max-w-full object-contain"
//                   />
//                 ) : attachmentType === "video" ? (
//                   <video controls className="w-full h-full max-h-[70vh]">
//                     <source
//                       src={currentAttachment}
//                       type={`video/${attachmentFilename.split(".").pop()}`}
//                     />
//                     Your browser does not support the video tag.
//                   </video>
//                 ) : attachmentType === "audio" ? (
//                   <audio controls className="w-full max-w-md">
//                     <source
//                       src={currentAttachment}
//                       type={`audio/${attachmentFilename.split(".").pop()}`}
//                     />
//                     Your browser does not support the audio element.
//                   </audio>
//                 ) : attachmentType === "pdf" ? (
//                   <iframe
//                     src={`${currentAttachment}#toolbar=0`}
//                     className="w-full h-full min-h-[50vh] border-none"
//                     title="PDF preview"
//                   />
//                 ) : ["word", "excel", "powerpoint"].includes(attachmentType) ? (
//                   <iframe
//                     src={getOfficeViewerUrl(currentAttachment)}
//                     className="w-full h-full min-h-[50vh] border-none"
//                     title={`${attachmentType} document preview`}
//                     allowFullScreen
//                   />
//                 ) : attachmentType === "text" ? (
//                   <iframe
//                     src={currentAttachment}
//                     className="w-full h-full min-h-[50vh] border-none"
//                     title="Text preview"
//                   />
//                 ) : (
//                   <div className="flex flex-col items-center justify-center h-full p-4">
//                     <p className="text-gray-500 mb-4 text-center">
//                       Preview not available for this file type
//                     </p>
//                     <button
//                       onClick={() =>
//                         handleDownloadAttachment(currentTodoForUnassign)
//                       }
//                       className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                     >
//                       Download File
//                     </button>
//                   </div>
//                 )}
//               </div>

//               <div className="mt-4 flex justify-end">
//                 <button
//                   onClick={() =>
//                     handleDownloadAttachment(currentTodoForUnassign)
//                   }
//                   className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                 >
//                   Download
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }







import React, { useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FaSearch, FaTimes, FaEdit, FaTrash } from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { toast } from "react-toastify";
import Select from "react-select";
import { PlusIcon } from "lucide-react";

export default function Todo() {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [todos, setTodos] = useState([]);
  const [activeTab, setActiveTab] = useState("assigned");
  const [isSearching, setIsSearching] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentTodoId, setCurrentTodoId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [todoToDelete, setTodoToDelete] = useState(null);
  const [currentTodoForUnassign, setCurrentTodoForUnassign] = useState(null);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const [attachmentType, setAttachmentType] = useState("");
  const [attachmentFilename, setAttachmentFilename] = useState("");
  const [expandedMessages, setExpandedMessages] = useState({});
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [statusOptions, setStatusOptions] = useState([]);

  const [newTodo, setNewTodo] = useState({
    file: null,
    companyId:
      user?.accountType === "COMPANY" ? user.id : user?.companyId || "",
    date: "",
    todoMessage: "",
    priority: "",
    createdById: user?.id || "",
    createdByName: user?.name || "",
    status: "",
    createdAt: new Date().toISOString(),
    todoType: "",
    assignedTo: "",
    assignedToOptions: [],
  });

  const [searchParams, setSearchParams] = useState({
    companyId: "",
    todoMessage: "",
    status: "",
    targetUserId: "",
  });

  useEffect(() => {
    async function fetchStatus() {
      if (!user) return;
      const companyId =
        user.accountType === "COMPANY" ? user.id : user.companyId;
      try {
        const response = await axios.get(
          `${API_URL}/api/leadStatus/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setStatusOptions(response.data || []);
      } catch (error) {
        console.error("Error fetching status:", error);
      }
    }
    fetchStatus();
  }, [user]);

  const handleNewTodoChange = (eOrValue, meta) => {
    if (meta && meta.name === "assignedToJson") {
      const assignedUsers = eOrValue.map((option) => ({
        id: option.value,
        name: option.label,
      }));

      setNewTodo((prev) => ({
        ...prev,
        assignedTo: JSON.stringify(assignedUsers),
        assignedToOptions: eOrValue, // Store the selected options
      }));
    } else {
      const { name, value, type, files } = eOrValue.target;
      if (type === "file") {
        setNewTodo((prev) => ({ ...prev, file: files[0] }));
      } else {
        setNewTodo((prev) => ({ ...prev, [name]: value }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newTodo.todoMessage || !newTodo.date) {
      toast.error("Todo message and date are required");
      return;
    }

    try {
      const formData = new FormData();

      Object.keys(newTodo).forEach((key) => {
        if (key !== "assignedToOptions" && newTodo[key] !== null) {
          formData.append(key, newTodo[key]);
        }
      });

      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const response =
        isEditing && currentTodoId
          ? await axios.put(
              `${API_URL}/api/todos/${currentTodoId}`,
              formData,
              config
            )
          : await axios.post(`${API_URL}/api/todos`, formData, config);

      const { status, message } = response.data;

      if (status === "Successful") {
        toast.success(message);
        setShowAddModal(false);
        fetchTodos(); 
        resetForm(); 
      } else {
        toast.error(message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Error submitting todo:", error);
      toast.error(error.response?.data?.message || "Failed to submit todo");
    }
  };

  const resetForm = () => {
    setNewTodo({
      file: null,
      companyId:
        user?.accountType === "COMPANY" ? user.id : user?.companyId || "",
      date: "",
      todoMessage: "",
      priority: "",
      createdById: user?.id || "",
      createdByName: user?.name || "",
      status: "",
      createdAt: new Date().toISOString(),
      todoType: "",
      assignedTo: "",
      assignedToOptions: [],
    });
    setIsEditing(false);
    setCurrentTodoId(null);
  };

  const handleEditClick = (todo) => {
    setCurrentTodoId(todo.todoId);
    setIsEditing(true);

    const assignedToOptions =
      todo.assignedTo && Array.isArray(todo.assignedTo)
        ? todo.assignedTo.map((user) => ({
            value: user.id,
            label: user.name,
          }))
        : [];

    setNewTodo({
      ...todo,
      assignedTo: JSON.stringify(todo.assignedTo || []),
      assignedToOptions,
    });

    setShowAddModal(true);
  };

  const toggleMessageExpansion = (todoId) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [todoId]: !prev[todoId],
    }));
  };

  const MAX_MESSAGE_LENGTH = 50; 

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setIsSearching(true);
    setPageNumber(0); 
    try {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;
      if (!companyId) return;

      const params = {
        ...Object.fromEntries(
          Object.entries(searchParams).filter(([_, v]) => v !== "")
        ),
        pageNumber: 0, 
        pageSize: pageSize,
      };

      const response = await axios.get(
        `${API_URL}/api/todos/searchTodos/${companyId}/${user?.id}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setTodos(response.data.todos || []);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      toast.error("Failed to search tasks");
      setTodos([]);
      setTotalPages(0);
    }
  };

  const handleClearSearch = () => {
    setIsSearching(false);
    setSearchParams({
      companyId: "",
      todoMessage: "",
      status: "",
      targetUserId: "",
    });
    setPageNumber(0); 
    fetchTodos();
  };

  const fetchTodos = useCallback(async () => {
    if (!user?.id) return;
    try {
      const endpoint =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/todos/company/${user.id}`
          : activeTab === "assigned"
          ? `${API_URL}/api/todos/assigned/${user.id}`
          : `${API_URL}/api/todos/createdBy/${user.id}`;

      const response = await axios.get(
        `${endpoint}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      setTodos(Array.isArray(response.data.todos) ? response.data.todos : []);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      setTodos([]);
      setTotalPages(0);
    }
  }, [user, activeTab, pageNumber, pageSize]);

  useEffect(() => {
    fetchTodos();
  }, [user, activeTab, fetchTodos, pageNumber, pageSize]);

  const handleViewAttachment = async (todo) => {
    try {
      const response = await axios.get(
        `${API_URL}/api/todos/view/${todo.todoId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const filename = todo.attachment;
      const fileExtension = filename.split(".").pop().toLowerCase();

      let typeCategory = "other";
      if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
        typeCategory = "image";
      } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
        typeCategory = "video";
      } else if (["mp3", "wav", "ogg"].includes(fileExtension)) {
        typeCategory = "audio";
      } else if (fileExtension === "pdf") {
        typeCategory = "pdf";
      } else if (["doc", "docx"].includes(fileExtension)) {
        typeCategory = "word";
      } else if (["xls", "xlsx"].includes(fileExtension)) {
        typeCategory = "excel";
      } else if (["ppt", "pptx"].includes(fileExtension)) {
        typeCategory = "powerpoint";
      } else if (["txt", "csv"].includes(fileExtension)) {
        typeCategory = "text";
      }

      let fileUrl;
      if (typeCategory === "pdf") {
        const blob = new Blob([response.data], { type: "application/pdf" });
        fileUrl = URL.createObjectURL(blob);
      } else {
        const blob = new Blob([response.data]);
        fileUrl = URL.createObjectURL(blob);
      }

      setCurrentAttachment(fileUrl);
      setAttachmentFilename(filename);
      setAttachmentType(typeCategory);
      setCurrentTodoForUnassign(todo.todoId);
      setShowAttachmentModal(true);
    } catch (error) {
      toast.error("Failed to view attachment");
      console.error(error);
    }
  };

  const handleDownloadAttachment = async (todoId) => {
    try {
      const todo = todos.find((t) => t.todoId === todoId);
      if (!todo || !todo.attachment) {
        toast.error("Attachment not found");
        return;
      }

      const response = await axios.get(
        `${API_URL}/api/todos/download/${todoId}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const filename = todo.attachment;

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Failed to download attachment");
      console.error(error);
    }
  };

  const getOfficeViewerUrl = (fileUrl) => {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
      fileUrl
    )}`;
  };

  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      const url =
        user?.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  const handleDeleteClick = (todoId) => {
    setTodoToDelete(todoId);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!todoToDelete) return;

    try {
      const response = await axios.delete(
        `${API_URL}/api/todos/${todoToDelete}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      toast.success(response.data.message);
      fetchTodos();
    } catch (error) {
      toast.error(error.response?.data?.message || error.message);
    } finally {
      setShowDeleteModal(false);
      setTodoToDelete(null);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
      
      {/* Updated Container with Consistent Padding */}
      <div className="bg-[#FAF8FF] dark:bg-gray-900 p-4 sm:p-5 rounded-lg shadow-lg cfg-font min-h-screen">
        
        {/* Header Section */}
        <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center mb-5">
          {/* Left: Title */}
          <h2 className="text-xl font-bold cfg-heading dark:text-white">Todo Table</h2>

          {/* Middle: Tabs (visible only if not COMPANY) */}
          {user?.accountType !== "COMPANY" && (
            <div className="flex flex-wrap gap-1 sm:gap-2">
              <button
                className={`px-3 py-1.5 rounded-md font-medium text-sm transition ${
                  activeTab === "assigned"
                    ? "bg-[#673AB7] text-white shadow-md"
                    : "bg-[#F3F4F6] text-[#374151] hover:bg-[#E5E7EB] dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 border border-[#E5E7EB] dark:border-gray-600"
                }`}
                onClick={() => setActiveTab("assigned")}
              >
                Assigned
              </button>
              <button
                className={`px-3 py-1.5 rounded-md font-medium text-sm transition ${
                  activeTab === "createdBy"
                    ? "bg-[#673AB7] text-white shadow-md"
                    : "bg-[#F3F4F6] text-[#374151] hover:bg-[#E5E7EB] dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 border border-[#E5E7EB] dark:border-gray-600"
                }`}
                onClick={() => setActiveTab("createdBy")}
              >
                Created By
              </button>
            </div>
          )}

          {/* Right: Search and Add buttons */}
          <div className="flex flex-wrap justify-end gap-2">
            <button
              onClick={() => {
                resetForm();
                setShowAddModal(true);
              }}
              type="button"
              className="px-3 py-1.5 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-sm transition flex items-center justify-center"
            >
              <PlusIcon className="w-5 h-5" />
            </button>
            <button
              type="button"
              onClick={() => setShowFields(!showFields)}
              className="px-3 py-1.5 bg-[#673AB7] text-white hover:bg-[#5E35A6] rounded-md shadow-sm flex items-center transition"
            >
              <FaSearch className="mr-2" />
              {showFields ? "Close" : "Search"}
            </button>
          </div>
        </div>

        {/* Search Section */}
        {showFields && (
          <form
            onSubmit={handleSearchSubmit}
            className="p-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-[#E5E7EB] dark:border-gray-700 mb-5 w-full"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 items-end">
              <div>
                <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                  User
                </label>
                <select
                  name="targetUserId"
                  value={searchParams.targetUserId}
                  onChange={handleSearchChange}
                  className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                >
                  <option value="">All</option>
                  {users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.fname} {user.lname}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                  Todo
                </label>
                <input
                  type="text"
                  name="todoMessage"
                  value={searchParams.todoMessage}
                  onChange={handleSearchChange}
                  placeholder="Enter subject"
                  className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                  Priority
                </label>
                <select
                  name="priority"
                  value={searchParams.priority}
                  onChange={handleSearchChange}
                  className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                >
                  <option value="">All</option>
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold mb-1 text-[#374151] dark:text-gray-200">
                  Status
                </label>
                <select
                  name="status"
                  value={searchParams.status}
                  onChange={handleSearchChange}
                  className="w-full p-2 text-xs border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                >
                  <option value="">All</option>
                  {statusOptions.map((status) => (
                    <option key={status.leadStatusId} value={status.name}>
                      {status.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="flex justify-end gap-2 mt-3">
              <button
                type="submit"
                className="px-3 py-1.5 text-xs bg-[#673AB7] text-white font-medium rounded-md hover:bg-[#5E35A6] shadow-sm transition flex items-center"
              >
                <FaSearch className="mr-1.5" /> Search
              </button>
              {isSearching && (
                <button
                  type="button"
                  onClick={handleClearSearch}
                  className="px-3 py-1.5 text-xs bg-[#F3F4F6] text-[#374151] font-medium rounded-md hover:bg-[#E5E7EB] transition dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 border border-[#E5E7EB] dark:border-gray-600"
                >
                  Clear
                </button>
              )}
            </div>
          </form>
        )}

        {/* Table Section */}
        <div className="overflow-x-auto bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-[#E5E7EB] dark:border-gray-700">
          <table className="min-w-full divide-y divide-[#E5E7EB] dark:divide-gray-700 text-sm">
            <thead className="bg-[#F3F4F6] dark:bg-gray-700 text-[#6B7280] dark:text-gray-300 uppercase tracking-wider text-xs">
              <tr>
                <th className="px-3 py-3 text-left font-semibold">S No.</th>
                <th className="px-3 py-3 text-left font-semibold">Todo</th>
                <th className="px-3 py-3 text-left font-semibold">Priority</th>
                <th className="px-3 py-3 text-left font-semibold">Date</th>
                <th className="px-3 py-3 text-left font-semibold">Assigned To</th>
                <th className="px-3 py-3 text-left font-semibold">Assigned By</th>
                <th className="px-3 py-3 text-left font-semibold">Status</th>
                <th className="px-3 py-3 text-left font-semibold">Attachment</th>
                {(user?.accountType === "COMPANY" || activeTab !== "assigned") && (
                  <th className="px-3 py-3 text-left font-semibold">Actions</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E5E7EB] dark:divide-gray-700 bg-white dark:bg-gray-800">
              {todos.length > 0 ? (
                todos.map((todo, index) => (
                  <tr key={todo.todoId} className="hover:bg-[#FAF8FF] dark:hover:bg-gray-700 transition-colors text-[#374151] dark:text-gray-200">
                    <td className="px-3 py-3 font-medium">
                      {pageNumber * pageSize + index + 1}
                    </td>
                    <td className="px-3 py-3 whitespace-pre-wrap break-words max-w-xs">
                      {todo.todoMessage.length > MAX_MESSAGE_LENGTH ? (
                        <>
                          {expandedMessages[todo.todoId]
                            ? todo.todoMessage
                            : `${todo.todoMessage.substring(0, MAX_MESSAGE_LENGTH)}...`}
                          <button
                            onClick={() => toggleMessageExpansion(todo.todoId)}
                            className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] ml-2 text-xs font-semibold transition"
                          >
                            {expandedMessages[todo.todoId] ? "View Less" : "View More"}
                          </button>
                        </>
                      ) : (
                        todo.todoMessage
                      )}
                    </td>
                    <td className="px-3 py-3">{todo.priority}</td>
                    <td className="px-3 py-3">{formatDate(todo.date)}</td>
                    <td className="px-3 py-3">
                      {todo.assignedTo && Array.isArray(todo.assignedTo)
                        ? todo.assignedTo.map((u) => (
                            <span key={u.id} className="inline-block bg-[#F3F4F6] dark:bg-gray-600 px-2 py-0.5 rounded text-xs mr-1 mb-1">
                              {u.name}
                            </span>
                          ))
                        : "—"}
                    </td>
                    <td className="px-3 py-3">{todo.createdByName}</td>
                    <td className="px-3 py-3">
                      <span className="bg-[#F3F4F6] dark:bg-gray-600 px-2 py-1 rounded text-xs font-medium border border-[#E5E7EB] dark:border-gray-500">
                        {todo.status}
                      </span>
                    </td>
                    <td className="px-3 py-3">
                      {todo.attachment ? (
                        <button
                          onClick={() => {
                            setCurrentTodoForUnassign(todo.todoId);
                            handleViewAttachment(todo);
                          }}
                          className="text-[#673AB7] underline hover:text-[#5E35A6] dark:text-[#E9D5FF] dark:hover:text-purple-300 text-sm font-medium"
                        >
                          View Attachment
                        </button>
                      ) : (
                        <span className="text-[#9CA3AF] italic text-sm">
                          No attachment
                        </span>
                      )}
                    </td>
                    {(user?.accountType === "COMPANY" || activeTab !== "assigned") && (
                      <td className="px-3 py-3">
                        <div className="flex items-center space-x-3">
                          <button
                            onClick={() => handleEditClick(todo)}
                            title="Edit"
                            className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] text-base transition-colors focus:outline-none"
                          >
                            <FaEdit />
                          </button>
                          <button
                            onClick={() => handleDeleteClick(todo.todoId)}
                            title="Delete"
                            className="text-[#EF4444] hover:text-[#B91C1C] dark:hover:text-[#FCA5A5] text-base transition-colors focus:outline-none"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="9"
                    className="text-center py-8 text-[#6B7280] dark:text-gray-400"
                  >
                    No todos found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Section */}
        {totalPages > 0 && (
          <div className="mt-5 flex flex-col sm:flex-row justify-between items-center gap-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-[#E5E7EB] dark:border-gray-700 shadow-sm">
            <div className="flex items-center gap-2 w-full sm:w-auto relative z-10">
              <span className="text-sm text-[#374151] dark:text-gray-300 whitespace-nowrap">
                Items per page:
              </span>
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setPageNumber(0);
                }}
                className="border border-[#E5E7EB] rounded-md p-1.5 text-sm dark:bg-gray-700 dark:text-white dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-w-[60px]"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
            </div>

            <div className="flex items-center gap-2 flex-wrap justify-center w-full sm:w-auto">
              <button
                onClick={() => setPageNumber(0)}
                disabled={pageNumber === 0}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded-md disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                title="First Page"
              >
                First
              </button>
              
              <button
                onClick={() => {
                  const newPage = Math.max(pageNumber - 1, 0);
                  setPageNumber(newPage);
                }}
                disabled={pageNumber === 0}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded-md disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                title="Previous Page"
              >
                Prev
              </button>

              <span className="text-sm font-medium text-[#374151] dark:text-gray-300 whitespace-nowrap px-2">
                Page {pageNumber + 1} of {totalPages}
              </span>

              <button
                onClick={() => {
                  const newPage = Math.min(pageNumber + 1, totalPages - 1);
                  setPageNumber(newPage);
                }}
                disabled={pageNumber >= totalPages - 1}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded-md disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                title="Next Page"
              >
                Next
              </button>
              
              <button
                onClick={() => setPageNumber(totalPages - 1)}
                disabled={pageNumber >= totalPages - 1}
                className="px-3 py-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-sm font-medium text-[#673AB7] rounded-md disabled:opacity-50 disabled:hover:bg-[#F3E8FF] transition-colors"
                title="Last Page"
              >
                Last
              </button>
            </div>
          </div>
        )}

        {/* Add/Edit Modal */}
        {showAddModal && (
          <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
            <div className="relative bg-white dark:bg-gray-800 w-full max-w-2xl rounded-xl shadow-2xl border border-[#E5E7EB] dark:border-gray-700 max-h-[95vh] flex flex-col">
              {/* Header */}
              <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
                <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
                  {isEditing ? "Edit Todo" : "Create New Todo"}
                </h2>
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    resetForm();
                  }}
                  className="text-[#6B7280] hover:text-[#EF4444] dark:text-gray-300 dark:hover:text-red-400 transition"
                  aria-label="Close"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>

              {/* Form */}
              <div className="p-6 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
                <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  {/* Todo Message */}
                  <div className="col-span-full">
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Todo Message <span className="text-[#EF4444]">*</span>
                    </label>
                    <textarea
                      name="todoMessage"
                      value={newTodo.todoMessage}
                      onChange={handleNewTodoChange}
                      placeholder="Enter todo message"
                      className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[100px] dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm"
                      required
                      rows={4}
                    />
                  </div>

                  {/* Date */}
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Date <span className="text-[#EF4444]">*</span>
                    </label>
                    <input
                      type="date"
                      name="date"
                      value={newTodo.date}
                      onChange={handleNewTodoChange}
                      min={new Date().toISOString().split("T")[0]}
                      className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm"
                      required
                    />
                  </div>

                  {/* Priority */}
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Priority <span className="text-[#EF4444]">*</span>
                    </label>
                    <select
                      name="priority"
                      value={newTodo.priority}
                      onChange={handleNewTodoChange}
                      className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm"
                      required
                    >
                      <option value="">Select Priority</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </select>
                  </div>

                  {/* Status */}
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Status
                    </label>
                    <select
                      name="status"
                      value={newTodo.status}
                      onChange={handleNewTodoChange}
                      className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm"
                    >
                      <option value="">Select Status</option>
                      {statusOptions.map((status) => (
                        <option
                          key={status.leadStatusId}
                          value={status.name}
                          style={{
                            backgroundColor: status.color,
                            color: "#fff",
                          }}
                        >
                          {status.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Todo Type */}
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Todo Type
                    </label>
                    <input
                      type="text"
                      name="todoType"
                      value={newTodo.todoType}
                      onChange={handleNewTodoChange}
                      placeholder="Optional"
                      className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm"
                    />
                  </div>

                  {/* File Upload */}
                  <div className="col-span-full border border-[#E5E7EB] dark:border-gray-700 p-4 rounded-lg bg-gray-50 dark:bg-gray-800/50">
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-2">
                      Attach File
                    </label>
                    <input
                      type="file"
                      name="file"
                      onChange={handleNewTodoChange}
                      className="w-full text-sm text-[#6B7280] dark:text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#F3E8FF] file:text-[#673AB7] hover:file:bg-[#E9D5FF] transition dark:file:bg-purple-900/50 dark:file:text-purple-300"
                    />
                  </div>

                  {/* Assign To */}
                  <div className="col-span-full">
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Assign To <span className="text-[#EF4444]">*</span>
                    </label>
                    <Select
                      isMulti
                      name="assignedToJson"
                      options={users.map((user) => ({
                        value: user.id,
                        label: `${user.fname} ${user.lname}`,
                      }))}
                      value={newTodo.assignedToOptions}
                      onChange={(selectedOptions, meta) =>
                        handleNewTodoChange(selectedOptions, meta)
                      }
                      className="w-full"
                      classNamePrefix="select"
                      closeMenuOnSelect={false}
                      placeholder="Select team members..."
                      required
                      noOptionsMessage={() => "No users available"}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "42px",
                          backgroundColor: document.documentElement.classList.contains('dark') ? '#374151' : '#ffffff',
                          borderColor: document.documentElement.classList.contains('dark') ? '#4b5563' : '#E5E7EB',
                          borderRadius: '0.375rem',
                          '&:hover': {
                            borderColor: document.documentElement.classList.contains('dark') ? '#6B7280' : '#8B5CF6',
                          },
                          boxShadow: state.isFocused ? (document.documentElement.classList.contains('dark') ? '0 0 0 2px #8B5CF6' : '0 0 0 2px #E9D5FF') : 'none',
                        }),
                        menu: (base) => ({
                          ...base,
                          backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#ffffff',
                          zIndex: 9999,
                        }),
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isFocused ? (document.documentElement.classList.contains('dark') ? '#4B5563' : '#F3F4F6') : state.isSelected ? '#673AB7' : 'transparent',
                          color: state.isSelected ? '#ffffff' : document.documentElement.classList.contains('dark') ? '#F9FAFB' : '#374151',
                          cursor: 'pointer',
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: document.documentElement.classList.contains('dark') ? '#4B5563' : '#F3E8FF',
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: document.documentElement.classList.contains('dark') ? '#F9FAFB' : '#673AB7',
                          fontWeight: '500',
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          color: document.documentElement.classList.contains('dark') ? '#F9FAFB' : '#673AB7',
                          ':hover': {
                            backgroundColor: document.documentElement.classList.contains('dark') ? '#6B7280' : '#E9D5FF',
                            color: document.documentElement.classList.contains('dark') ? '#ffffff' : '#673AB7',
                          },
                        }),
                      }}
                    />
                  </div>

                  {/* Buttons */}
                  <div className="col-span-full flex justify-end gap-3 mt-4 border-t border-[#E5E7EB] dark:border-gray-700 pt-5">
                    <button
                      type="button"
                      onClick={() => setShowAddModal(false)}
                      className="px-5 py-2.5 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-6 py-2.5 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] transition font-semibold text-sm shadow-md"
                    >
                      {isEditing ? "Update" : "Create"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {showDeleteModal && (
          <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-6 w-full max-w-sm border border-[#E5E7EB] dark:border-gray-700 transform transition-all scale-100">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-[#FEF2F2] dark:bg-red-900/30 flex items-center justify-center mb-4">
                  <FaTrash className="text-[#EF4444] text-xl" />
                </div>
                <h3 className="text-xl font-bold text-[#1F2937] dark:text-white mb-2 cfg-heading">
                  Delete Todo
                </h3>
                <p className="text-[#6B7280] dark:text-gray-400 text-center mb-6 text-sm">
                  Are you sure you want to delete this todo? This action cannot be undone.
                </p>
                <div className="flex justify-center gap-3 w-full">
                  <button
                    onClick={() => {
                      setShowDeleteModal(false);
                      setTodoToDelete(null);
                    }}
                    className="flex-1 px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={confirmDelete}
                    className="flex-1 px-4 py-2 bg-[#EF4444] text-white rounded-md hover:bg-[#B91C1C] shadow-md transition font-semibold text-sm"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Attachment Modal */}
        {showAttachmentModal && (
          <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-4 sm:p-6 w-full max-w-4xl h-[90vh] flex flex-col border border-[#E5E7EB] dark:border-gray-700">
              <div className="flex justify-between items-center mb-4 border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
                <h3 className="text-lg font-bold cfg-heading text-[#1F2937] dark:text-white truncate max-w-[80%]">
                  {attachmentFilename}
                </h3>
                <button
                  onClick={() => {
                    setShowAttachmentModal(false);
                    if (currentAttachment) {
                      URL.revokeObjectURL(currentAttachment);
                    }
                  }}
                  className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 transition"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>

              <div className="flex-1 flex flex-col items-center justify-center overflow-hidden bg-gray-50 dark:bg-gray-900 rounded-lg border border-[#E5E7EB] dark:border-gray-700 p-2">
                {attachmentType === "image" ? (
                  <img
                    src={currentAttachment}
                    alt="Attachment preview"
                    className="max-h-full max-w-full object-contain rounded"
                  />
                ) : attachmentType === "video" ? (
                  <video controls className="w-full h-full max-h-[70vh] rounded">
                    <source
                      src={currentAttachment}
                      type={`video/${attachmentFilename.split(".").pop()}`}
                    />
                    Your browser does not support the video tag.
                  </video>
                ) : attachmentType === "audio" ? (
                  <audio controls className="w-full max-w-md rounded-full shadow-sm">
                    <source
                      src={currentAttachment}
                      type={`audio/${attachmentFilename.split(".").pop()}`}
                    />
                    Your browser does not support the audio element.
                  </audio>
                ) : attachmentType === "pdf" ? (
                  <iframe
                    src={`${currentAttachment}#toolbar=0`}
                    className="w-full h-full min-h-[50vh] border-none rounded bg-white"
                    title="PDF preview"
                  />
                ) : ["word", "excel", "powerpoint"].includes(attachmentType) ? (
                  <iframe
                    src={getOfficeViewerUrl(currentAttachment)}
                    className="w-full h-full min-h-[50vh] border-none rounded bg-white"
                    title={`${attachmentType} document preview`}
                    allowFullScreen
                  />
                ) : attachmentType === "text" ? (
                  <iframe
                    src={currentAttachment}
                    className="w-full h-full min-h-[50vh] border-none rounded bg-white dark:bg-gray-800"
                    title="Text preview"
                  />
                ) : (
                  <div className="flex flex-col items-center justify-center h-full p-8 bg-white dark:bg-gray-800 rounded-lg">
                    <p className="text-[#6B7280] font-medium mb-4 text-center dark:text-gray-300">
                      Preview not available for this file type
                    </p>
                    <button
                      onClick={() =>
                        handleDownloadAttachment(currentTodoForUnassign)
                      }
                      className="px-5 py-2.5 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] shadow-md transition"
                    >
                      Download File
                    </button>
                  </div>
                )}
              </div>

              <div className="mt-4 flex justify-end pt-3 border-t border-[#E5E7EB] dark:border-gray-700">
                <button
                  onClick={() =>
                    handleDownloadAttachment(currentTodoForUnassign)
                  }
                  className="px-6 py-2.5 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] shadow-md transition"
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}